import React from "react";
import { Button } from "antd";
import { ForkOutlined } from "@ant-design/icons";

import colors from "../../themes/colors";

const TransactionSplitButton = ({
  onClick,
  small = false,
  isDisabled,
}: {
  onClick: () => void;
  small?: boolean;
  isDisabled?: boolean;
}) => {
  const text = small ? "Split" : "Split transaction";
  const styles = {
    display: "flex",
    alignItems: "center",
    ...(small ? { border: "none" } : {}),
  };
  return (
    <Button
      onClick={onClick}
      icon={<ForkOutlined style={{ color: colors.purple }} />}
      size="large"
      style={styles}
      data-test="splitButton"
      disabled={isDisabled}
    >
      {text}
    </Button>
  );
};

export default TransactionSplitButton;
